import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! License details at fancyapps.com/license */
import { isPlainObject as e } from "../utils/isPlainObject.js";
var t = {
    showLoading: !0,
    preload: 1
  },
  a = "is-lazyloading",
  s = "is-lazyloaded",
  l = function l() {
    var l;
    function n() {
      var a = null == l ? void 0 : l.getOptions().Lazyload;
      return e(a) ? Object.assign(Object.assign({}, t), a) : t;
    }
    function o(e) {
      var t;
      var o = e.el;
      if (!o) return;
      var i = "[data-lazy-src],[data-lazy-srcset],[data-lazy-bg]",
        d = Array.from(o.querySelectorAll(i));
      o.matches(i) && d.push(o);
      var _loop = function _loop() {
        var o = _d[_i];
        var i = o.dataset.lazySrc,
          d = o.dataset.lazySrcset,
          r = o.dataset.lazySizes,
          c = o.dataset.lazyBg,
          u = (o instanceof HTMLImageElement || o instanceof HTMLSourceElement) && (i || d),
          f = o instanceof HTMLElement && c;
        if (!u && !f) return 1; // continue
        var m = i || d || c;
        if (m) {
          if (u && m) {
            var _c = null === (t = o.parentElement) || void 0 === t ? void 0 : t.classList.contains("f-panzoom__wrapper");
            n().showLoading && (null == l || l.showLoading(e)), o.addEventListener("load", function () {
              null == l || l.hideLoading(e), o instanceof HTMLImageElement ? o.decode().then(function () {
                o.classList.remove(a), o.classList.add(s);
              }) : (o.classList.remove(a), o.classList.add(s)), _c || null == l || l.emit("lazyLoad:loaded", e, o, m);
            }), o.addEventListener("error", function () {
              null == l || l.hideLoading(e), o.classList.remove(a), o.classList.add("has-lazyerror"), _c || null == l || l.emit("lazyLoad:error", e, o, m);
            }), o.classList.add("f-lazyload"), o.classList.add(a), _c || null == l || l.emit("lazyLoad:load", e, o, m), i && (o.src = i), d && (o.srcset = d), r && (o.sizes = r);
          } else if (f) {
            if (!document.body.contains(o)) {
              document.createElement("img").src = c;
            }
            o.style.backgroundImage = "url('".concat(c, "')");
          }
          delete o.dataset.lazySrc, delete o.dataset.lazySrcset, delete o.dataset.lazySizes, delete o.dataset.lazyBg;
        }
      };
      for (var _i = 0, _d = d; _i < _d.length; _i++) {
        if (_loop()) continue;
      }
    }
    function i() {
      if (!l) return;
      var e = _toConsumableArray(l.getVisibleSlides()),
        t = n().preload;
      if (t > 0) {
        var _a = l.getPosition(),
          _s = l.getViewportDim();
        e.push.apply(e, _toConsumableArray(l.getVisibleSlides(_a + _s * t)).concat(_toConsumableArray(l.getVisibleSlides(_a - _s * t))));
      }
      var _iterator = _createForOfIteratorHelper(e),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t = _step.value;
          o(_t);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return {
      init: function init(e) {
        l = e, l.on("render", i);
      },
      destroy: function destroy() {
        null == l || l.off("render", i), l = void 0;
      }
    };
  };
export { l as Lazyload };